import {connect} from 'react-redux';
import {closeModal} from 'shared/actions/modal';
import {deleteStudent} from 'src/redux/student/user';
import RequestInstitutionModal, {
  RequestInstitutionModalProps,
} from 'src/components/RequestInstitutionModal/RequestInstitutionModal';
import {requestInstitution} from './actions';
import {Store} from 'src/types/store';
import {EducationPhase} from 'src/types/enums';

const mapStateToProps = (
  state: Store,
  ownProps: Pick<RequestInstitutionModalProps, 'stateKeyAttribute'> & {
    userId?: string;
    type?: string;
  }
) => {
  const {modal, requestInstitutionModal} = state;

  const relevantState = state[ownProps.stateKeyAttribute || 'registration'];

  let userId = ownProps.userId;
  let type = ownProps.type;

  if (typeof userId !== 'string' || typeof type !== 'string') {
    const {_id, educationPhase} = relevantState;
    userId = _id;
    type = relevantState.type;

    if (!type && educationPhase && educationPhase === EducationPhase.COMMUNITY_COLLEGE) {
      type = 'transfer';
    }
  }

  return {
    type: type || '',
    userId: userId || '',
    requested: Boolean(requestInstitutionModal.requested),
    email: requestInstitutionModal.email,
    show: Boolean(modal.requestInstitution),
  };
};

export default connect(mapStateToProps, {
  requestInstitution,
  deleteStudent,
  closeModal,
})(RequestInstitutionModal);
